module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAbCAMAAAD7/nnYAAAAPFBMVEUAAAAODg4ICAgPDw8AAAAAAAAAAAAODg4ODg4AAAAAAAAAAAAAAAAAAAAAAAAPDw8PDw8AAAAAAAAAAABNWvZ1AAAAE3RSTlMA/olW9fDB1dSwkU9MGBft7L4G+QYM8QAAAJBJREFUOMvdlUkOxCAMBNtmSUIgy/T//zrDaU5IyD4lde+SZaABUO9IE+mu+KF0oMBOFzsyuTWYaBuZEckGIwcZQRJmSL5E8CeVj09AlolYWGQNI0GayEsnDAQTC1nl1FMWu0BEoSKeCS69xhN4d5C8p1DcF+mZb8EnSN5G6p14GPO9E92t7P8XgJojTcRcgS9Jsy41Xw0XzQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottomIcon1.png
// module id = 1sx/
// module chunks = 2